import React from 'react';

import styles from '../styles.module.scss';
import antiWebhookStyles from './AntiWebhook.module.scss';
import {AntiWebhookFeature} from '../AntiWebhookFeature';
import {ArrowLong} from '../../../assets';

export const AntiWebhookCard = () => {
  return (
    <div className={antiWebhookStyles.card}>
      <div className={styles.top}>
        <div className={styles.label}>
          <div className={styles.labelInner}>SECURITY</div>
        </div>
        <div className={styles.buttonForward}>
          <ArrowLong />
        </div>
      </div>
      <h4 className={styles.title}>Anti-Webhook</h4>
      <p className={styles.subTitle}>
        Prevents server members from using webhooks without permission. The algorithm is based on
        several indicators that indicate the possibility of a malicious webhook being created.
      </p>
      <div className={antiWebhookStyles.feature}>
        <AntiWebhookFeature />
      </div>
    </div>
  );
};
